import {Plugins} from '@capacitor/core'

/**
 * splash 제어 함수들 반환합니다
 */
export const useSplashscreen = () => {
  return Plugins.SplashScreen
}
